import React from 'react'

// import * as strings from '../../helpers/strings';
// import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';

import HealthSummary from '../../health-data/view/StationsSummary';
import StationInfo from './StationInfo';


const StationInfoAndHealthStatus = () => {
  return (
    <Grid container spacing={8}>
        <Grid item md={12} sm={12} xs={12}>
        {/* <Typography variant="h5" color={strings.colorPrimary} title={strings.lblDashboardStationInfo}>{strings.lblDashboardStationInfo}</Typography> */}
        </Grid>
        <Grid item md={6} sm={12} xs={12}>
            <HealthSummary />
        </Grid>
        <Grid  item md={6} sm={12} xs={12}>
            <StationInfo />
        </Grid>
    </Grid>
  )
}

export default StationInfoAndHealthStatus